import { render } from "./ChipGroup.vue?vue&type=template&id=7273ba4e"
import script from "./ChipGroup.vue?vue&type=script&lang=js"
export * from "./ChipGroup.vue?vue&type=script&lang=js"
script.render = render

export default script